import { useCallback } from 'react';
import { useNavigation, useRoute } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { useTelemetry } from '@order/Telemetry';

import type { MenuTabStackParamList } from '../../navigation/AppNavigation.props';

// ────────────────────────────────────────────────────────────────────────────────

export const useNavigateToMenuCollection = () => {
  // `push` method is used to prevent scrolling issue on web platform
  const { push } =
    useNavigation<NativeStackNavigationProp<MenuTabStackParamList>>();
  const { track } = useTelemetry();

  const { params } = useRoute();
  const { addressId, restaurantSlug } =
    (params as Readonly<{
      addressId: string;
      restaurantSlug: string;
    }>) ?? {};

  // ─────────────────────────────────────────────────────────────────

  return useCallback(
    (selectedMenuCollectionId: string) => {
      const menuCollectionId = selectedMenuCollectionId;

      track('menu.view_collection', { collectionId: menuCollectionId });

      if (addressId) {
        push('DeliveryMenuCollection', { addressId, menuCollectionId });

        return;
      }

      if (restaurantSlug) {
        push('MenuCollection', { restaurantSlug, menuCollectionId });
      }
    },
    [addressId, restaurantSlug, push, track],
  );
};
